/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../../app/@shared/tracking/memory-leak-tracking.component';
import * as import2 from '../../../../app/@shared/tracking/error-tracking.service';
import * as import3 from '../../../../app/@shared/tracking/tracking.config';
const styles_MemoryLeakTrackingComponent:any[] = ([] as any[]);
export const RenderType_MemoryLeakTrackingComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MemoryLeakTrackingComponent,
  data: {}
}
);
export function View_MemoryLeakTrackingComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_MemoryLeakTrackingComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'fl-memory-leak-tracking',([] as any[]),(null as any),(null as any),(null as any),View_MemoryLeakTrackingComponent_0,RenderType_MemoryLeakTrackingComponent)),
    import0.ɵdid(114688,(null as any),0,import1.MemoryLeakTrackingComponent,[
      import2.ErrorTracking,
      import3.TRACKING_CONFIG
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const MemoryLeakTrackingComponentNgFactory:import0.ComponentFactory<import1.MemoryLeakTrackingComponent> = import0.ɵccf('fl-memory-leak-tracking',import1.MemoryLeakTrackingComponent,View_MemoryLeakTrackingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9tZW1vcnktbGVhay10cmFja2luZy5jb21wb25lbnQudHMuTWVtb3J5TGVha1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL21lbW9yeS1sZWFrLXRyYWNraW5nLmNvbXBvbmVudC50cy5NZW1vcnlMZWFrVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1tZW1vcnktbGVhay10cmFja2luZz48L2ZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lCQ0FBOzs7O0lDQUE7Z0JBQUE7OztJQUFBO0tBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/@shared/tracking/memory-leak-tracking.component.ngfactory.ts